<template>
    <Dashboard
        :title="__('Create question', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Create question', null, $page.props.profile_locale)"
            :description="'<span class=\'text-red-700\'>' + product.name + '</span>'"
            :backLink="route('dashboard.admin.product.questions', product.id)"
        />

        <div class="grid grid-cols-2 gap-3">
            <InputLabel
                id="question"
                :label="__('Question', null, $page.props.profile_locale)"
                class="col-span-2 "
                v-model="form.question"
            />
            <InputLabel
                id="answer"
                type="textarea"
                rows="5"
                :label="__('Answer', null, $page.props.profile_locale)"
                class="col-span-2"
                v-model="form.answer"
            />

            <div class="col-span-2 flex justify-start">
                <Button
                    color="gray"
                    padding="md"
                    @click="save()"
                >
                {{__('Save', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Heading from 'COMP/Heading';
import InputLabel from 'UI/InputLabel';
import Button from 'UI/Button';

import { useForm } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Dashboard,
        Heading,
        InputLabel,
        Button
    },
    props: ['product', 'question'],
    setup(props) {

        const form = useForm({
            question: props.question ? props.question.question : '',
            answer: props.question ? props.question.answer : '',
            product_id: props.product.id,
        });


        function save() {
            form.post(route('product.question.' + (props.question ? 'update' : 'store'), props.question ? props.question.id : ''), {
                preserveScroll: true,
                onSuccess: () => { if(!props.question) form.reset() },
            })
        }

        return {
            form,

            save
        }
    }
}
</script>

<style>

</style>
